import React, { useState, useEffect, useMemo, useRef } from "react";
import { useParams } from "react-router-dom";
import { 
  Card, 
  Checkbox, 
  Button, 
  Modal, 
  Form, 
  Radio, 
  Select, 
  Space, 
  Typography, 
  Row, 
  Col, 
  Tag, 
  message,
  Tooltip,
  Divider,
  Collapse
} from 'antd';
import { 
  SettingOutlined, 
  SaveOutlined, 
  AppstoreOutlined, 
  TeamOutlined,
  MobileOutlined,
  GlobalOutlined,
  CheckCircleOutlined,
  UserOutlined,
  EditOutlined,
  DeleteOutlined,
  BankOutlined,
  CheckCircleFilled,
  DownOutlined,
  RightOutlined
} from '@ant-design/icons';
import Api from "../../../../services/api";

const { Title, Text } = Typography;
const { Option } = Select;
const { Panel } = Collapse;

function Permission() {
  const [loading, setLoading] = useState(false);
  const [userInfo, setUserInfo] = useState(null); 
  const [apps, setApps] = useState([]);
  const [appLabelMap, setAppLabelMap] = useState({});
  const [studios, setStudios] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedPermission, setSelectedPermission] = useState(null);
  const [permissionScope, setPermissionScope] = useState('studio');
  const [selectedStudio, setSelectedStudio] = useState(undefined);
  const [selectedApps, setSelectedApps] = useState([]);
  const [checkAll, setCheckAll] = useState(false);
  const [form] = Form.useForm();
  const [initializedSelection, setInitializedSelection] = useState(false);
  const [userPermissions, setUserPermissions] = useState([]); 
  const [permissionsLoaded, setPermissionsLoaded] = useState(false);
  const [allUserPermissions, setAllUserPermissions] = useState([]); 
  const [allSystemPermissions, setAllSystemPermissions] = useState([]); 

  
  const getUserDetailCalled = useRef(new Set());
  const fetchAllPermissionsCalled = useRef(false);
  const loadStudiosCalled = useRef(false);
  const loadUserPermissionsCalled = useRef(new Set());

  const { user } = useParams();

  const normalizeOptionValue = (rawId, options) => {
    const hit = options.find(opt => String(opt.value) === String(rawId));
    return hit ? hit.value : rawId;
  };

  const getUserDetail = () => {
    if (getUserDetailCalled.current.has(user)) return;
    getUserDetailCalled.current.add(user);
    
    Api.get(`/api/admin/${user}`)
      .then(res => {
        if (res?.data?.code == 0) {
          setUserInfo(res.data.data);
        }
      })
      .catch(error => {
        console.error('getUserDetail API error:', error);
      });
  }

  const isGlobalUser = useMemo(() => !!(userInfo && !userInfo.studio_id), [userInfo]);
  const isAdminUser = useMemo(() => !!(userInfo && (userInfo.is_admin === 1 || userInfo.is_admin === true)), [userInfo]);
  const roleHas = useMemo(() => (code) => !!(userInfo?.roles || []).some(r => (r.permissions || []).some(p => String(p.code) === String(code))), [userInfo]);
  const isOwnerStudio = useMemo(() => !!(userInfo && userInfo.studio_id && ((userInfo.roles || []).some(r => String(r.code || '').toLowerCase().includes('owner')) || roleHas('owner.studio'))), [userInfo, roleHas]);
  const isGlobalAdminViewing = useMemo(() => !!(isGlobalUser && isAdminUser), [isGlobalUser, isAdminUser]);
  const shouldShowApps = () => {
    
    
    return !isOwnerStudio;
  };

  const fetchAllPermissions = () => {
    if (fetchAllPermissionsCalled.current) return;
    fetchAllPermissionsCalled.current = true;
    
    
    const endpoints = ['/api/permission', '/api/me/permissions'];
    
    const tryEndpoints = (index = 0) => {
      if (index >= endpoints.length) {
        console.log('All endpoints failed, using mock data');
        setAllSystemPermissions([
          { code: 'app.view', name: 'Xem app' },
          { code: 'user.create', name: 'Tạo user' },
          { code: 'user.edit', name: 'Sửa user' },
          { code: 'user.delete', name: 'Xóa user' },
          { code: 'role.create', name: 'Tạo role' },
          { code: 'role.edit', name: 'Sửa role' },
          { code: 'studio.create', name: 'Tạo studio' },
          { code: 'studio.edit', name: 'Sửa studio' }
        ]);
        return;
      }
      
      Api.get(endpoints[index])
        .then(res => {
          if (res?.data?.code == 0) {
            setAllSystemPermissions(res.data.data || []);
          } else {
            tryEndpoints(index + 1);
          }
        })
        .catch(error => {
          console.log(`Error loading permissions from ${endpoints[index]}:`, error);
          tryEndpoints(index + 1);
        });
    };
    
    tryEndpoints();
  }

  const handleUserPermission = () => {}

  const openPermissionModal = (permissionCode) => {
    setSelectedPermission(permissionCode);
    const permissionDetail = { code: 'app.view', resource_type: 'app_info', resource_id: selectedApps };
    if (permissionDetail && permissionDetail.resource_type) {
      if (permissionDetail.resource_type === 'app_info') {
        setPermissionScope('app');
        const ids = Array.isArray(permissionDetail.resource_id) ? permissionDetail.resource_id : [permissionDetail.resource_id];
        setSelectedApps(ids.filter(Boolean).map(id => normalizeOptionValue(id, apps)));
        setSelectedStudio(undefined);
      } else if (permissionDetail.resource_type === 'studio') {
        setPermissionScope('studio');
        setSelectedStudio(normalizeOptionValue(permissionDetail.resource_id, studios));
        setSelectedApps([]);
      } else {
        setPermissionScope('studio');
        setSelectedStudio(undefined);
        setSelectedApps([]);
      }
    } else {
      setPermissionScope('global');
      setSelectedStudio(undefined);
      setSelectedApps([]);
    }
    setShowModal(true);
  }

  const savePermissionDetail = () => {
    if (!selectedPermission) return;
    setShowModal(false);
    message.success('Đã cập nhật phân quyền chi tiết');
  }

  const savePermission = () => {
    if (isOwnerStudio) {
      
      return;
    }
    setLoading(true);
    const payload = [{ code: 'app.view', resource_type: 'app_info', resource_id: selectedApps }];
    Api.put(`/api/admin/${user}/permissions`, { permissions: payload })
      .then(response => {
        setLoading(false);
        if (response?.data?.code == 0) {
          message.success('Cập nhật quyền thành công!');
          
          setUserPermissions(payload);
          
          setCheckAll(apps.length > 0 && selectedApps.length === apps.length);
          
          getUserDetail();
        } else {
          message.error('Có lỗi xảy ra!');
        }
      })
      .catch(error => {
        setLoading(false);
        message.error('Có lỗi xảy ra!');
      });
  }

  const loadApps = (studioId) => {
    
    const params = {};
    if (isOwnerStudio) params.status = 'running'; 
    
    
    if (userInfo && userInfo.id) {
      params.target_user_id = userInfo.id;
    }
    
    Api.get('/api/app_list', { params })
      .then(response => {
        if (response?.data?.code == 0) {
          const map = {};
          const appOptions = response.data.data.map(app => {
            const code = app.code || app.bundle_id || app.name;
            const os = app.os;
            const codeLabel = `${code}(${os})`;
            map[String(app.id)] = codeLabel;
            return {
              value: app.app_info_id || app.id, 
              label: codeLabel,
              code,
              os,
              name: app.name || code,
              codeLabel,
              thumb: app.thumb
            };
          });
          setApps(appOptions);
          setAppLabelMap(map);
        }
      })
      .catch(error => {
        console.log('Error loading apps:', error);
        setApps([
          { value: 1, label: 'Game A (android)' },
          { value: 2, label: 'Game B (ios)' },
          { value: 3, label: 'Game C (android)' }
        ]);
      });
  }

  
  const loadUserPermissions = () => {
    if (loadUserPermissionsCalled.current.has(user)) return;
    loadUserPermissionsCalled.current.add(user);
    
    setPermissionsLoaded(false);
    Api.get(`/api/admin/${user}/permissions`)
      .then(res => {
        if (res?.data?.code == 0) {
          setUserPermissions(res.data.data || []);
        }
      })
      .catch(error => {
        console.error('loadUserPermissions API error:', error);
        setUserPermissions([]);
      })
      .finally(() => setPermissionsLoaded(true));
  }

  
  const getAllUserPermissions = () => {
    const permissions = [];
    
    
    if (userInfo?.roles) {
      userInfo.roles.forEach(role => {
        if (role.permissions) {
          role.permissions.forEach(permission => {
            permissions.push({
              ...permission,
              source: 'role',
              roleName: role.name,
              roleCode: role.code
            });
          });
        }
      });
    }
    
    
    if (userPermissions) {
      userPermissions.forEach(permission => {
        permissions.push({
          ...permission,
          source: 'direct'
        });
      });
    }
    
    
    const uniquePermissions = [];
    const seenCodes = new Set();
    
    permissions.forEach(permission => {
      if (!seenCodes.has(permission.code)) {
        seenCodes.add(permission.code);
        uniquePermissions.push(permission);
      }
    });
    
    setAllUserPermissions(uniquePermissions);
  }

  
  
  
  
  useEffect(() => {
    if (!initializedSelection && apps.length > 0) {
      if (isOwnerStudio || isGlobalAdminViewing) {
        const allIds = apps.map(a => a.value);
        setSelectedApps(allIds);
        setCheckAll(true);
        setInitializedSelection(true);
        return;
      }
      
      if (!permissionsLoaded) {
        return;
      }
      
      const appViewPerms = (userPermissions || []).filter(p => String(p.code) === 'app.view');
      const ids = new Set();
      appViewPerms.forEach(p => {
        if (Array.isArray(p.resource_id)) {
          p.resource_id.forEach(id => ids.add(String(id)));
        } else if (p.resource_id !== undefined && p.resource_id !== null) {
          ids.add(String(p.resource_id));
        }
      });
      const appIds = new Set(apps.map(a => String(a.value)));
      const selected = Array.from(ids).filter(id => appIds.has(id));
      setSelectedApps(selected);
      setCheckAll(selected.length > 0 && selected.length === apps.length);
      setInitializedSelection(true);
    }
  }, [apps, userPermissions, initializedSelection, permissionsLoaded]);

  const loadStudios = () => {
    if (loadStudiosCalled.current) return;
    loadStudiosCalled.current = true;
    
    Api.get('/api/studios')
      .then(response => {
        if (response?.data?.code == 0) {
          const studioOptions = response.data.data.map(studio => ({
            value: studio.id,
            label: studio.name,
            merchant_id: studio.merchant_id || studio.id
          }));
          setStudios(studioOptions);
          
        }
      })
      .catch(error => {
        console.log('Error loading studios:', error);
        setStudios([
          { value: 1, label: 'Studio 1' },
          { value: 2, label: 'Studio 2' },
          { value: 3, label: 'Studio 3' }
        ]);
      });
  }

  const getPermissionIcon = (permissionCode) => {
    switch (permissionCode) {
      case 'app.view':
        return <AppstoreOutlined style={{ color: '#1890ff' }} />;
      case 'user.create':
        return <UserOutlined style={{ color: '#52c41a' }} />;
      case 'user.edit':
        return <EditOutlined style={{ color: '#faad14' }} />;
      case 'user.delete':
        return <DeleteOutlined style={{ color: '#ff4d4f' }} />;
      case 'role.create':
        return <TeamOutlined style={{ color: '#722ed1' }} />;
      case 'role.edit':
        return <SettingOutlined style={{ color: '#fa8c16' }} />;
      case 'studio.create':
        return <BankOutlined style={{ color: '#13c2c2' }} />;
      case 'studio.edit':
        return <EditOutlined style={{ color: '#eb2f96' }} />;
      default:
        return <CheckCircleOutlined style={{ color: '#722ed1' }} />;
    }
  };

  const getScopeIcon = () => null;

  const getScopeText = (resourceType, resourceId) => {
    switch (resourceType) {
      case 'studio':
        const studio = studios.find(s => String(s.value) === String(resourceId));
        return `Toàn studio: ${studio?.label || resourceId}`;
      case 'app_info':
        const formatItem = (id) => {
          const app = apps.find(a => String(a.value) === String(id));
          if (app) {
            const code = app.code || '';
            const os = app.os || '';
            return `${code}(${os})`;
          }
          return id;
        };
        if (Array.isArray(resourceId)) {
          return `App cụ thể: ${resourceId.map(formatItem).join(', ')}`;
        }
        return `App cụ thể: ${formatItem(resourceId)}`;
      default:
        return 'Toàn hệ thống';
    }
  };

  const quickEnableAndConfigureAppView = () => {
    openPermissionModal('app.view');
  };

  useEffect(() => {
    fetchAllPermissions();
    loadStudios();
  }, []);

  useEffect(() => {
    if (userInfo) {
      setInitializedSelection(false); 
      loadApps(null);
      loadUserPermissions();
    }
  }, [userInfo]);

  
  useEffect(() => {
    getAllUserPermissions();
  }, [userInfo, userPermissions]);

  useEffect(() => {}, []);

  useEffect(() => {
    getUserDetail();
  }, []);

  return (
    <>
      <div className="background-second-dashboard">
        <section className="main__content-dashbard">
          <div className="container-fluid">
            <Card>
              {/* Header hiển thị thông tin user */}
              <div style={{ 
                padding: '20px 0', 
                borderBottom: '1px solid #f0f0f0', 
                marginBottom: '24px',
                textAlign: 'center'
              }}>
                <Space direction="vertical" size="small">
                  <UserOutlined style={{ fontSize: '30px', color: '#1890ff' }} />
                  <Title level={3} style={{ margin: 0 }}>
                    {userInfo?.name || 'N/A'}
                  </Title>
                  <Text type="secondary" style={{ fontSize: '16px' }}>
                    {userInfo?.email || 'N/A'}
                  </Text>
                </Space>
              </div>

              <Row gutter={24}>
                <Col xs={24} lg={12}>
                  <Row gutter={[16, 16]}>
                    {/* Card Roles */}
                    <Col span={24}>
                      <Card 
                        title={<Space><TeamOutlined />Roles</Space>} 
                        bodyStyle={{ background: 'transparent' }}
                        size="small" 
                      >
                        {isAdminUser ? (
                          <Collapse 
                            ghost
                            expandIcon={({ isActive }) => isActive ? <DownOutlined /> : <RightOutlined />}
                            expandIconPosition="right"
                            defaultActiveKey={['admin-role']}
                          >
                            <Panel 
                              header={
                                <Space>
                                  <TeamOutlined style={{ color: '#52c41a' }} />
                                  <Text strong style={{ fontSize: '14px' }}>Admin</Text>
                                  <Tag color="green" size="small">admin</Tag>
                                  <Text type="secondary" style={{ fontSize: '12px' }}>
                                    ({(allSystemPermissions || []).length} permissions)
                                  </Text>
                                </Space>
                              } 
                              key="admin-role"
                              style={{
                                marginBottom: '8px',
                                border: '1px solid #52c41a',
                                borderRadius: '6px'
                              }}
                            >
                              <div style={{ 
                                padding: '12px 16px', 
                                background: '#f6ffed',
                                borderRadius: '4px',
                                border: '1px solid #b7eb8f'
                              }}>
                                <Space wrap>
                                  {(allSystemPermissions || []).map(p => (
                                    <Tag 
                                      key={p.code} 
                                      color="green" 
                                      style={{ 
                                        marginBottom: 4,
                                        fontSize: '12px',
                                        padding: '2px 8px'
                                      }}
                                    >
                                      {p.name || p.code}
                                    </Tag>
                                  ))}
                                  {(!allSystemPermissions || allSystemPermissions.length === 0) && (
                                    <Text type="secondary" style={{ fontSize: '12px' }}>
                                      Đang tải permissions...
                                    </Text>
                                  )}
                                </Space>
                              </div>
                            </Panel>
                          </Collapse>
                        ) : userInfo?.roles && userInfo.roles.length > 0 ? (
                          <Collapse 
                            ghost
                            expandIcon={({ isActive }) => isActive ? <DownOutlined /> : <RightOutlined />}
                            expandIconPosition="right"
                          >
                            {userInfo.roles.map(role => (
                              <Panel 
                                header={
                                  <Space>
                                    <TeamOutlined style={{ color: '#1890ff' }} />
                                    <Text strong style={{ fontSize: '14px' }}>{role.name}</Text>
                                    <Tag color="blue" size="small">{role.code}</Tag>
                                    <Text type="secondary" style={{ fontSize: '12px' }}>
                                      ({(role.permissions || []).length} permissions)
                                    </Text>
                                  </Space>
                                } 
                                key={role.id}
                                style={{
                                  marginBottom: '8px',
                                  border: '1px solid #f0f0f0',
                                  borderRadius: '6px'
                                }}
                              >
                                <div style={{ 
                                  padding: '12px 16px', 
                                  background: '#fafafa',
                                  borderRadius: '4px',
                                  border: '1px solid #e8e8e8'
                                }}>
                                  <Space wrap>
                                    {(role.permissions || []).map(p => (
                                      <Tag 
                                        key={p.code} 
                                        color="green" 
                                        style={{ 
                                          marginBottom: 4,
                                          fontSize: '12px',
                                          padding: '2px 8px'
                                        }}
                                      >
                                        {p.name || p.code}
                                      </Tag>
                                    ))}
                                    {(!role.permissions || role.permissions.length === 0) && (
                                      <Text type="secondary" style={{ fontSize: '12px' }}>
                                        Role chưa có permission
                                      </Text>
                                    )}
                                  </Space>
                                </div>
                              </Panel>
                            ))}
                          </Collapse>
                        ) : (
                          <Collapse 
                            ghost
                            expandIcon={({ isActive }) => isActive ? <DownOutlined /> : <RightOutlined />}
                            expandIconPosition="right"
                          >
                            <Panel 
                              header={
                                <Space>
                                  <TeamOutlined style={{ color: '#1890ff' }} />
                                  <Text strong style={{ fontSize: '14px' }}>User Studio</Text>
                                  <Tag color="blue" size="small">user-studio</Tag>
                                  <Text type="secondary" style={{ fontSize: '12px' }}>
                                    (User Studio permissions)
                                  </Text>
                                </Space>
                              } 
                              key="user-studio-role"
                              style={{
                                marginBottom: '8px',
                                border: '1px solid #f0f0f0',
                                borderRadius: '6px'
                              }}
                            >
                              <div style={{ 
                                padding: '12px 16px', 
                                background: '#fafafa',
                                borderRadius: '4px',
                                border: '1px solid #e8e8e8'
                              }}>
                                <Space wrap>
                                  <Text type="secondary" style={{ fontSize: '12px' }}>
                                    User Studio có quyền cơ bản trong studio
                                  </Text>
                                </Space>
                              </div>
                            </Panel>
                          </Collapse>
                        )}
                      </Card>
                    </Col>

                    {/* Card Permissions */}
                    <Col span={24}>
                    <Card 
                        title={<Space><SettingOutlined />Permissions</Space>} 
                        bodyStyle={{ background: 'transparent' }}
                      size="small" 
                      >
                        <div style={{ maxHeight: 400, overflowY: 'auto' }}>
                          <Space direction="vertical" style={{ width: '100%' }}>
                            {isAdminUser ? (
                              
                              (allSystemPermissions || []).map((permission, idx) => (
                                <div 
                                  key={`${permission.code}-${idx}`}
                                  style={{
                                    padding: '8px 12px',
                                    borderRadius: '6px',
                                    background: '#f6ffed',
                                    border: '1px solid #b7eb8f',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between',
                                    minHeight: '40px'
                                  }}
                                >
                                  <Space>
                                    <SettingOutlined style={{ color: '#52c41a' }} />
                                    <Text strong style={{ fontSize: '14px' }}>
                                      {permission.name || permission.code}
                                    </Text>
                                  </Space>
                                  <div>
                                    <Tag color="green" size="small">Admin</Tag>
                                  </div>
                                </div>
                              ))
                            ) : (
                              
                              (allUserPermissions || []).map((permission, idx) => (
                                <div 
                                  key={`${permission.code}-${idx}`}
                                  style={{
                                    padding: '8px 12px',
                                    borderRadius: '6px',
                                    background: '#f6ffed',
                                    border: '1px solid #b7eb8f',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between',
                                    minHeight: '40px'
                                  }}
                                >
                                  <Space>
                                    <SettingOutlined style={{ color: '#52c41a' }} />
                                    <Text strong style={{ fontSize: '14px' }}>
                                      {permission.name || permission.code}
                                    </Text>
                                  </Space>
                                  <div>
                                    {permission.source === 'role' ? (
                                      <Tag color="blue" size="small">
                                        Từ Role: {permission.roleName}
                                      </Tag>
                                    ) : (
                                      <Tag color="green" size="small">Đã gán</Tag>
                                    )}
                                    {permission.resource_type && (
                                      <Tag color="orange" size="small" style={{ marginLeft: 4 }}>
                                        {permission.resource_type}
                                      </Tag>
                                    )}
                                  </div>
                                </div>
                              ))
                            )}
                            {!isAdminUser && (!allUserPermissions || allUserPermissions.length === 0) && (
                              <div style={{ 
                                textAlign: 'center', 
                                padding: '20px',
                                color: '#999'
                              }}>
                                <SettingOutlined style={{ fontSize: '24px', marginBottom: '8px' }} />
                                <div>Chưa có permission</div>
                              </div>
                            )}
                          </Space>
                        </div>
                    </Card>
                    </Col>
                  </Row>
                </Col>
                { (shouldShowApps() || isOwnerStudio) && (
                <Col xs={24} lg={12}>
                  <Card title={<Space><AppstoreOutlined />List apps</Space>} bodyStyle={{ background: 'transparent' }} extra={
                    <Space>
                      {!isOwnerStudio && !isGlobalAdminViewing && (
                        <>
                          <Button 
                            type="primary" 
                            icon={<SaveOutlined />}
                            onClick={savePermission}
                            loading={loading}
                            size="small"
                          >
                            Lưu quyền
                          </Button>
                          <Button size="small" onClick={() => setSelectedApps(apps.map(a => a.value))}>Chọn tất cả</Button>
                          <Button size="small" onClick={() => setSelectedApps([])}>Bỏ chọn</Button>
                        </>
                      )}
                    </Space>
                  }>
                    <div style={{ maxHeight: 650, overflowY: 'auto', overflowX: 'hidden', paddingRight: 4 }}>
                    <Row gutter={[16,16]} style={{ marginLeft: 0, marginRight: 0 }}>
                      {apps.map(app => {
                        const isActive = selectedApps.some(id => String(id) === String(app.value));
                        return (
                          <Col xs={24} sm={12} key={app.value}>
                            <div
                              onClick={() => {
                                if (isOwnerStudio || isGlobalAdminViewing) return;
                                setSelectedApps(prev => {
                                  const set = new Set(prev.map(v => String(v)));
                                  if (isActive) set.delete(String(app.value)); else set.add(String(app.value));
                                  return Array.from(set);
                                });
                              }}
                              style={{
                                borderRadius: 12,
                                padding: 16,
                                background: '#fff',
                                display: 'flex',
                                alignItems: 'center',
                                cursor: (isOwnerStudio || isGlobalAdminViewing) ? 'not-allowed' : 'pointer',
                                transition: '0.2s',
                                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
                                border: '1px solid #ddd',
                                position: 'relative',
                                filter: isActive ? 'none' : 'grayscale(100%)',
                                opacity: isActive ? 1 : 0.8
                              }}
                            >
                              {isActive && (
                                <CheckCircleFilled style={{ position: 'absolute', top: 8, right: 8, color: '#52c41a', fontSize: 18 }} />
                              )}
                              <div className="app-img me-3" style={{ position: 'relative', width: 60, height: 60, borderRadius: 12, overflow: 'hidden' }}>
                                <img src={app.thumb} alt={app.name} style={{ width: 60, height: 60, objectFit: 'cover', display: 'block' }} />
                                <img alt="" src={`/bg-${app.os}.png`} style={{ position: 'absolute', top: 0, left: 0, width: 60, height: 60, borderRadius: 12, pointerEvents: 'none' }} />
                              </div>
                              <div className="app-title" style={{ flex: 1, minWidth: 0 }}>
                                <div style={{ fontWeight: 600, color: '#000', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{app.code} - {app.name}</div>
                              </div>
                            </div>
                          </Col>
                        );
                      })}
                    </Row>
                    </div>
                  </Card>
                </Col>
                )}
              </Row>
            </Card>
          </div>
        </section>
      </div>

      <Modal
        title={<Text style={{ fontSize: '16px', fontWeight: '600' }}>Phân quyền {selectedPermission}</Text>}
        open={showModal}
        onCancel={() => setShowModal(false)}
        onOk={savePermissionDetail}
        width={700}
        okText="Lưu cấu hình"
        cancelText="Hủy"
      >
        <div style={{ padding: '20px 0' }}>
          <Form form={form} layout="vertical">
            <Form.Item>
              <Radio.Group
                value={permissionScope}
                onChange={(e) => setPermissionScope(e.target.value)}
                style={{ width: '100%' }}
              >
                <Space direction="vertical" style={{ width: '100%' }} size="large">
                  <div style={{ 
                    padding: '16px', 
                    border: '2px solid #f0f0f0', 
                    borderRadius: '12px',
                    backgroundColor: permissionScope === 'global' ? '#f6ffed' : '#fafafa',
                    borderColor: permissionScope === 'global' ? '#52c41a' : '#f0f0f0'
                  }}>
                    <Radio value="global" style={{ fontSize: '14px' }}>
                      Toàn hệ thống (User Global xem tất cả app)
                    </Radio>
                  </div>
                  
                  <div style={{ 
                    padding: '16px', 
                    border: '2px solid #f0f0f0', 
                    borderRadius: '12px',
                    backgroundColor: permissionScope === 'studio' ? '#f6ffed' : '#fafafa',
                    borderColor: permissionScope === 'studio' ? '#52c41a' : '#f0f0f0'
                  }}>
                    <Radio value="studio" style={{ fontSize: '14px' }}>
                      Toàn studio (xem tất cả app thuộc studio đã chọn)
                    </Radio>
                    {permissionScope === 'studio' && (
                      <div style={{ marginTop: '16px', marginLeft: '32px' }}>
                        <Select
                          placeholder="Chọn studio"
                          style={{ width: '100%' }}
                          size="middle"
                          value={selectedStudio}
                          onChange={(value) => setSelectedStudio(value)}
                          showSearch
                          optionFilterProp="children"
                        >
                          {studios.map(studio => (
                            <Option key={studio.value} value={studio.value}>
                              <Space>
                                <TeamOutlined />
                                {studio.label}
                              </Space>
                            </Option>
                          ))}
                        </Select>
                      </div>
                    )}
                  </div>
                  
                  <div style={{ 
                    padding: '16px', 
                    border: '2px solid #f0f0f0', 
                    borderRadius: '12px',
                    backgroundColor: permissionScope === 'app' ? '#f6ffed' : '#fafafa',
                    borderColor: permissionScope === 'app' ? '#52c41a' : '#f0f0f0'
                  }}>
                    <Radio value="app" style={{ fontSize: '14px' }}>
                      App cụ thể (chỉ xem danh sách app được chọn)
                    </Radio>
                    {permissionScope === 'app' && (
                      <div style={{ marginTop: '16px', marginLeft: '32px' }}>
                        <Select
                          mode="multiple"
                          placeholder="Chọn app"
                          style={{ width: '100%' }}
                          size="middle"
                          value={selectedApps}
                          onChange={(values) => setSelectedApps(values)}
                          showSearch
                          optionFilterProp="label"
                          options={apps}
                          tagRender={({ label, value, closable, onClose }) => (
                            <Tag closable={closable} onClose={onClose} style={{ marginRight: 3 }}>
                              {label || appLabelMap[String(value)] || value}
                            </Tag>
                          )}
                        />
                      </div>
                    )}
                  </div>
                </Space>
              </Radio.Group>
            </Form.Item>
          </Form>
        </div>
      </Modal>
    </>
  );
}

export default Permission;